export var BlobTypes = /*#__PURE__*/ function(BlobTypes) {
    BlobTypes["Image"] = "image/*";
    BlobTypes["Pdf"] = "application/pdf";
    BlobTypes["Csv"] = "text/csv";
    BlobTypes["Docx"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    BlobTypes["Xlsx"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    BlobTypes["Xls"] = "application/vnd.ms-excel";
    BlobTypes["Doc"] = "application/msword";
    BlobTypes["Txt"] = "text/plain";
    BlobTypes["Json"] = "application/json";
    BlobTypes["Xml"] = "application/xml";
    BlobTypes["Html"] = "text/html";
    return BlobTypes;
}({});
